import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const StyledScheduleToolbar = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  width: '100%',
}));

export const StyledScheduleToolbarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '320px',
  gap: theme.spacing(2),
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));
